import { render } from "./AppRightMenu.vue?vue&type=template&id=d75550e0"
import script from "./AppRightMenu.vue?vue&type=script&lang=js"
export * from "./AppRightMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/web.digitalsystemsrl.it/web.digitalsystemsrl.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__